/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './symptom-attribute.reducer';

export const SymptomAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const symptomAttributeEntity = useAppSelector(state => state.symptomAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="symptomAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.symptomAttribute.detail.title">SymptomAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.name">Name</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.name}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.value}</dd>
          <dt>
            <span id="valueType">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.valueType">Value Type</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.valueType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.symptomAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{symptomAttributeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.symptomAttribute.parent">Parent</Translate>
          </dt>
          <dd>{symptomAttributeEntity.parent ? symptomAttributeEntity.parent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/symptom-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/symptom-attribute/${symptomAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SymptomAttributeDetail;
